import { gql } from '@apollo/client'

export const GET_ROUTES = gql`
  query GetRoutes($pagination: TPagination, $input: TRoutesInput) {
    troutes(input: $input, pagination: $pagination) {
      total
      items {
        id
        name
        intermediateStops @client
        origin @client
        destination @client
        polyline {
          distance
        }
        company {
          id
          name
        }
        segments {
          origin {
            id
          }
          destination {
            id
          }
          companyLineSpecs {
            distance
            duration
          }
        }
        stops {
          id
          name
          code
        }
        services {
          id
          isActive
          code
        }
      }
    }
  }
`

export const GET_ROUTE = gql`
  query GetRoute($routeId: UUID!) {
    troute(input: { id: $routeId }) {
      id
      name
      businessClient {
        id
        name
      }
      businessSite {
        id
        name
      }
      company {
        id
        name
        vertical
      }
      stops {
        id
        name
        timezone
      }
      companyLines {
        id
        name
      }
      segments {
        companyLineSpecs {
          distance
          duration
          id
        }
        origin {
          timezone
          id
        }
        destination {
          timezone
          id
        }
      }
      polyline {
        encoded
        distance
      }
      origin @client
      destination @client
      intermediateStops @client
    }
  }
`

export const GET_ROUTE_WITH_STOPS_V2 = gql`
  query GetRouteV2($stopIDs: [UUID!]!, $companyID: UUID) {
    troute(input: { stopIDs: $stopIDs, companyID: $companyID }) {
      id
      name
      company {
        id
        name
        vertical
      }
      stops {
        id
        name
        timezone
      }
      companyLines {
        id
        name
      }
      segments {
        companyLineSpecs {
          distance
          duration
          id
        }
        origin {
          timezone
          id
        }
        destination {
          timezone
          id
        }
      }
      origin @client
      destination @client
      intermediateStops @client
    }
  }
`

export const GET_ROUTES_AUTOCOMPLETE = gql`
  query GetRoutesAutocomplete {
    troutesAutocomplete {
      total
      items {
        id
        name
      }
    }
  }
`

export const GET_ROUTES_SUGGESTIONS = gql`
  query GetRoutesSuggestions($input: RouteSuggestionsInput!) {
    routeSuggestions(input: $input) {
      total
      items {
        id
        name
      }
    }
  }
`
